import React from "react";

import clsx from "clsx";

import { Label, UnstyledButton } from "@busbud/horizon";

import { useAppContext } from "@app/helpers/hooks";
import {
  PageSection,
  selectDropdownItem
} from "@app/tracking/dropdown-tracking";
import type { Tracker } from "@app/tracking/tracker";
import { redirect } from "@app/utils/window";

export interface NavigationItem {
  label: string;
  Icon: React.ComponentType<{ className?: string }>;
  url: string;
  account_section: string;
}

interface Props extends NavigationItem {
  selected: boolean;
}

const onItemClick = (tracker: Tracker, section: string, url: string) => {
  tracker.track(
    selectDropdownItem("account_menu", PageSection.Navigation, {
      clicked_section: section
    })
  );
  redirect(url);
};

export const AccountNavigationItem: React.FC<Props> = ({
  account_section,
  Icon,
  label,
  url,
  selected = false
}) => {
  const { tracker } = useAppContext();

  return (
    <UnstyledButton
      className={clsx(
        "flex cursor-pointer items-center gap-150 rounded-md p-150",
        {
          "bg-color-scheme-literal-blue-100 text-color-scheme-interactive-cta-600":
            selected,
          "text-color-tertiary": !selected
        }
      )}
      onClick={() => onItemClick(tracker, account_section, url)}
    >
      <span
        className={clsx({
          "text-color-scheme-interactive-cta-600": selected,
          "text-icon-color-primary": !selected
        })}
      >
        <Icon />
      </span>
      <Label as="span" fontWeight="bold" size="md">
        {label}
      </Label>
    </UnstyledButton>
  );
};
